import { formValueSelector } from 'redux-form';
import evaluatePostfixCondition from './evaluatePostfixCondition'; // Used to get the redux-form field value

export var fieldValueSelector = formValueSelector('birForm'); // Given state(to extract form values) and sectionFields list, returns the information about wether the section should be shown or not
// based on evaluated field conditions

export var getSectionConditionsInfo = function getSectionConditionsInfo(state) {
  var sectionFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var fieldsWithConditions = sectionFields.filter(function (field) {
    return field.conditionPostfix && field.conditionPostfix.length;
  });
  var allFieldsHaveConditions = fieldsWithConditions.length === sectionFields.length;

  if (!allFieldsHaveConditions) {
    return {
      allFieldsHaveConditions: allFieldsHaveConditions
    };
  }

  var fieldIdToFormValue = function fieldIdToFormValue(fieldId) {
    return fieldValueSelector(state, fieldId);
  };

  var sectionConditions = fieldsWithConditions.map(function (field) {
    return field.conditionPostfix;
  });
  var someFieldConditionsFulfilled = sectionConditions.map(function (condition) {
    return evaluatePostfixCondition(condition, fieldIdToFormValue);
  }).some(function (v) {
    return v;
  });
  return {
    allFieldsHaveConditions: allFieldsHaveConditions,
    someFieldConditionsFulfilled: someFieldConditionsFulfilled
  };
};
export var getFieldItemConditionsInfo = function getFieldItemConditionsInfo(state, _ref) {
  var id = _ref.id,
      condition = _ref.condition,
      arrayMember = _ref.arrayMember,
      fields = _ref.fields;
  var currentFieldId = id.split('.').pop();
  var currentField = fields.find(function (f) {
    return f.id === currentFieldId;
  });

  if (!condition || !condition.length) {
    return {};
  }

  var fieldIdToFormValue = function fieldIdToFormValue(fieldId) {
    var field = fields.find(function (f) {
      return f.id === fieldId.split('.').pop();
    });

    if (field && !!field.loopingGroup && field.loopingGroup === currentField.loopingGroup) {
      return fieldValueSelector(state, "".concat(arrayMember, ".").concat(fieldId));
    }

    return fieldValueSelector(state, fieldId);
  };

  var conditionSuccess = evaluatePostfixCondition(condition, fieldIdToFormValue);
  return {
    conditionFail: !conditionSuccess
  };
};
export var getFieldArrayContainerConditionsInfo = function getFieldArrayContainerConditionsInfo(state, _ref2) {
  var loopingGroup = _ref2.loopingGroup,
      fields = _ref2.fields;
  var fieldConditions = loopingGroup.fields.map(function (f) {
    return f.conditionPostfix;
  });
  var fieldConditionsCount = fieldConditions.filter(function (condition) {
    return condition && condition.length;
  }).length;
  var allFieldsHaveCondition = !!(fieldConditionsCount == loopingGroup.fields.length);

  if (!allFieldsHaveCondition) {
    return {};
  }

  var fieldIdToFormValue = function fieldIdToFormValue(fieldId) {
    var field = fields.find(function (f) {
      return f.id === fieldId;
    });

    if (field.loopingGroup) {
      var loopingGroupMemberName = field.loopingGroup.replace(/\s+/g, '-');
      return fieldValueSelector(state, "".concat(loopingGroupMemberName, ".").concat(fieldId));
    }

    return fieldValueSelector(state, fieldId);
  };

  var someFieldConditionsFulfilled = fieldConditions.map(function (condition) {
    return evaluatePostfixCondition(condition, fieldIdToFormValue);
  }).some(function (v) {
    return v;
  });
  return {
    allFieldsHaveCondition: allFieldsHaveCondition,
    someFieldConditionsFulfilled: someFieldConditionsFulfilled
  };
};